import { Button, Modal } from "@/components/atoms";

export const DuplicateConfirmModal = ({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Modal
    open={open}
    onClose={onClose}
    variant="web-small"
    title="Duplicate Vehicle Type"
    description="Create a copy of this vehicle type with the same settings. You can update the details after duplicating."
    renderButtons={() => (
      <>
        <Button variant="secondary" onClick={onClose} className="flex-1">
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} className="flex-1">
          Duplicate Type
        </Button>
      </>
    )}
  />
);
